import { render, staticRenderFns } from "./bf-link.vue?vue&type=template&id=8ff91b9e&scoped=true&lang=pug&"
import script from "./bf-link.vue?vue&type=script&lang=js&"
export * from "./bf-link.vue?vue&type=script&lang=js&"
import style0 from "./bf-link.vue?vue&type=style&index=0&id=8ff91b9e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff91b9e",
  null
  
)

export default component.exports